<div class="main-container">
    <div class="toolbar">
        <div class="buttons-container">
            <button type="button" nz-button nzType="primary" nzShape="circle" (click)="addRow()"
                nz-tooltip [nzTooltipTitle]="'actions.add'|translateTA">
                <span nz-icon nzType="plus"></span>
            </button>
            <button type="button" nz-button nzDanger nzShape="circle" (click)="deleteRow()"
                nz-tooltip [nzTooltipTitle]="'actions.delete'|translateTA">
                <span nz-icon nzType="delete"></span>
            </button>
            <button type="button" nz-button nzShape="circle" (click)="massChange()"
                nz-tooltip [nzTooltipTitle]="'actions.masschange'|translateTA">
                <span nz-icon nzType="check-square"></span>
            </button>
            <nz-divider nzType="vertical" class="toolbar-divider"></nz-divider>
            <button type="button" nz-button nzShape="circle" (click)="iaROW()"
                nz-tooltip [nzTooltipTitle]="'actions.ia'|translateTA">
                <span nz-icon nzType="robot"></span>
            </button>
        </div>
        <span class="title">{{'translate.title'|translateTA}}</span>
    </div>

    <div class="tem-field filter-field">
        <span class="tem-field-label">{{'translate.placeholer'|translateTA}}</span>
        <nz-input-group [nzSuffix]="filterSuffix">
            <input nz-input #input [placeholder]="'translate.placeholer'|translateTA"
                (keyup)="applyFilter($event)" />
        </nz-input-group>
        <ng-template #filterSuffix>
            <span nz-icon nzType="search"></span>
        </ng-template>
    </div>

    <div class="table-container">
        <nz-spin [nzSpinning]="loading" class="table-spin">
            <nz-table #table nzSize="small"
                [nzData]="filteredRows"
                [nzPageSizeOptions]="[50, 100, 500]"
                [(nzPageSize)]="pageSize"
                [(nzPageIndex)]="pageIndex"
                [nzShowSizeChanger]="true"
                [nzNoResult]="noResultTpl">
                <thead>
                    <tr>
                        <th nzWidth="48px">
                            <label nz-checkbox
                                [ngModel]="selection.hasValue() && isAllSelected()"
                                [nzIndeterminate]="selection.hasValue() && !isAllSelected()"
                                (ngModelChange)="toggleAllRows()">
                            </label>
                        </th>
                        <th nzWidth="110px" [nzSortFn]="sortByInternalId">InternalId.</th>
                        <th [nzSortFn]="sortByTag">Tag. ID</th>
                        <th class="col-center" *ngFor="let item of languages" [nzSortFn]="sortFns[item.col]">{{item.name}}</th>
                        <th class="col-center" nzWidth="130px">{{'actions'|translateTA}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let row of table.data" (click)="selection.toggle(row)">
                        <td (click)="$event.stopPropagation()">
                            <label nz-checkbox
                                [ngModel]="selection.isSelected(row)"
                                (ngModelChange)="selection.toggle(row)">
                            </label>
                        </td>
                        <td>{{row.INTERNALID}}</td>
                        <td>{{row.ID}}</td>
                        <td *ngFor="let item of languages">
                            <textarea nz-input rows="2" [(ngModel)]="row[item.col]"
                                [disabled]="!row.editMode" (click)="$event.stopPropagation()"></textarea>
                        </td>
                        <td>
                            <div class="button-flex-container" (click)="$event.stopPropagation()">
                                <button type="button" nz-button nzType="primary" nzShape="circle"
                                    (click)="editRow($event,row,row.editMode?'save':'edit')"
                                    nz-tooltip [nzTooltipTitle]="(row.editMode?'actions.save':'actions.edit')|translateTA">
                                    <span nz-icon [nzType]="row.editMode?'check':'edit'"></span>
                                </button>
                                <button type="button" nz-button nzShape="circle" [disabled]="!row.editMode"
                                    (click)="cancelEditRow($event,row)"
                                    nz-tooltip [nzTooltipTitle]="'cancel'|translateTA">
                                    <span nz-icon nzType="close"></span>
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </nz-table>
            <ng-template #noResultTpl>
                <div class="no-data-row">{{"simpledatagrid.norows"|translateTA}} {{filterText}}</div>
            </ng-template>
        </nz-spin>
    </div>
</div>
